/**
 * 約定ティッカーの表示件数の窓 (#9581)。 取得は全件のまま、 画面側で新しい順に 100 件ずつ描画する。
 * 板ヘッダーの約定件数・約定量・最終約定価格は全件から算出するので、 ここでは件数の窓だけを決める。
 */

/** 1 回に描画する約定の件数 (初回表示と、 下端までスクロールするごとの追加分)。 */
export const MARKET_TICKER_PAGE_SIZE = 100

/** 下端までこの距離 (px) に近づいたら次の件数を描画する (行 4 本分ほど手前から先読みする)。 */
const MARKET_TICKER_LOAD_MORE_DISTANCE_PX = 200

/** スクロール領域の位置 (DOM の scrollTop / clientHeight / scrollHeight)。 */
export type ScrollMetrics = {
  scrollTop: number
  clientHeight: number
  scrollHeight: number
}

/** 下端まで `MARKET_TICKER_LOAD_MORE_DISTANCE_PX` 以内にいるか。 */
export function isNearScrollEnd({
  scrollTop,
  clientHeight,
  scrollHeight,
}: ScrollMetrics): boolean {
  return (
    scrollHeight - scrollTop - clientHeight <=
    MARKET_TICKER_LOAD_MORE_DISTANCE_PX
  )
}

/** 次に描画する件数。 全件 (`total`) を超えない。 */
export function nextTickerVisibleCount(
  visibleCount: number,
  total: number,
): number {
  return Math.min(visibleCount + MARKET_TICKER_PAGE_SIZE, total)
}
